import React from "react";
import PropTypes from "prop-types";
import ScriptTag from "@components/ScriptTag";
import { isServer } from "@lib/helpers";
import _get from "lodash/get";
import getConfig from "next/config";
import ContentEditorProductDescription from "@components/ProductPage/ProductDescription/ContentEditorProductDescription";
import StaticHTMLProductDescription from "@components/ProductPage/ProductDescription/StaticHTMLProductDescription";

const {
  publicRuntimeConfig: { contentProviders },
} = getConfig();

const EStoreMediaProductDescription = ({
  ean,
  contentEditorBlock,
  staticHTML,
  brand,
}) => (
  <>
    <div id="esc-rich-content">
      {/* Fallback content gets automatically replaced on success */}
      {contentEditorBlock.length !== 0 ? (
        <ContentEditorProductDescription
          contentEditorBlock={contentEditorBlock}
          staticHTML={staticHTML}
          ean={ean}
          brand={brand}
        />
      ) : (
        <StaticHTMLProductDescription
          staticHTML={staticHTML}
          ean={ean}
          brand={brand}
        />
      )}
    </div>

    {!isServer && (
      <ScriptTag
        type="text/javascript"
        src="https://delivery.estorecontent.com/static/rich_content.js"
        data-shop-id={_get(
          contentProviders,
          "providers.eStoreMedia.shopId",
          ""
        )}
        data-content-language="ro"
        data-product-code={ean}
        data-page-embed-id="esc-rich-content"
        async
      />
    )}
  </>
);

EStoreMediaProductDescription.propTypes = {
  staticHTML: PropTypes.string.isRequired,
  contentEditorBlock: PropTypes.string.isRequired,
  ean: PropTypes.string.isRequired,
  brand: PropTypes.string.isRequired,
};

export default EStoreMediaProductDescription;
